export default "/_next/static/media/enjoei-attributes-custom-1024x775.7197e8c3a09059016544f49b2de26fe5.png";